import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO51 = () => {

  return (
    <StaticImage
      src="../../images/JPG-MALE-LOOK005-1.jpg"
      
      alt="Reserved avatar"
    />
  )
}

export default ImageMO51
